export enum MapActionsSnackbar {
    NOME_MODULO = 'snackbar',

    SET_SNACKBAR_SHOW = 'setSnackbarShow',

    SET_SNACKBAR = 'setSnackbar',
    SET_SNACKBAR_SUCCESS = 'setSnackbarSuccess',
    SET_SNACKBAR_ERROR = 'setSnackbarError',

    LIMITADOR = '/'
}

export class MapActionsSnackbarModule {
   static SET_SNACKBAR_SUCCESS = `${MapActionsSnackbar.NOME_MODULO}${MapActionsSnackbar.LIMITADOR}${MapActionsSnackbar.SET_SNACKBAR_SUCCESS}`;

   static SET_SNACKBAR_ERROR = `${MapActionsSnackbar.NOME_MODULO}/${MapActionsSnackbar.SET_SNACKBAR_ERROR}`;
}
